module.exports = __webpack_public_path__ + "media/dalibao0808.65fc3fa1.mp4";